"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const choices_1 = require("../../utils/choices");
const utils_1 = require("../../utils/utils");
const constants_1 = require("../../constants/constants");
const theme_1 = __importDefault(require("../../styles/theme"));
const text_1 = __importStar(require("../text/text"));
const styles_1 = __importDefault(require("../../styles/styles"));
const textStyles_1 = __importDefault(require("../text/textStyles"));
const SummaryRow = ({ label, value, fieldName = '', extraText = '' }) => {
    let newValue;
    /* eslint indent: [2, 4, {"SwitchCase": 1}] */
    switch (fieldName) {
        case 'loanAmount':
            if (typeof value === 'number') {
                newValue = constants_1.NAIRA_SYMBOL + (0, utils_1.formatNumber)(value);
            }
            break;
        case 'loanReason':
            if (typeof value === 'number') {
                newValue = (0, utils_1.getLabel)(choices_1.loanReasonChoices, value);
                break;
            }
            break;
        case 'periodicity':
            if (typeof value === 'number') {
                newValue = (0, utils_1.getLabel)(choices_1.periodicityChoices, value);
            }
            break;
        case 'tenor':
            if (typeof value === 'number') {
                newValue = (0, utils_1.getLabel)(choices_1.lengthChoices, value);
            }
            break;
        case 'title':
            if (typeof value === 'number') {
                newValue = (0, utils_1.getLabel)(choices_1.titleChoices, value);
            }
            break;
        case 'gender':
            if (typeof value === 'number' || typeof value === 'string') {
                if (value === 1) {
                    newValue = 'Male';
                }
                else if (value === 2) {
                    newValue = 'Female';
                }
            }
            break;
        case 'canProvideCheque':
            newValue = value.toString();
            break;
        default:
            if (typeof value !== 'string') {
                newValue = value.toString();
            }
            else {
                newValue = value;
            }
    }
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.flexDirectionRow] },
            react_1.default.createElement(react_native_1.View, { style: [{ flex: 2, justifyContent: 'center' }] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: textStyles_1.default.bold }, label),
                extraText !== '' && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.flexDirectionRow] },
                    react_1.default.createElement(react_native_1.View, { style: { justifyContent: 'center' } },
                        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_GRAY_DARK }, extraText))))),
            !!newValue && (react_1.default.createElement(react_native_1.View, { style: { flex: 1, justifyContent: 'center', alignItems: 'flex-end' } },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, biggerSubtitle: true, style: textStyles_1.default.bold }, newValue))))));
};
SummaryRow.defaultProps = {
    fieldName: '',
    extraText: undefined,
};
exports.default = SummaryRow;
